import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function getincidents(payload) {
  try {
    const data = await authenticatedFetch(URL.fetchIncidentsApi, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return data;
  } catch (error) {
    console.error("Error executing incident report:", error);
    throw error;
  }
}
